import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { DELETE_CHALLENGE_MUTATION } from '../graphql/mutations'
import { DELETE_CHALLENGE } from '../redux/action-types'

const useDeleteChallengeMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(store => store.challenges.challenges)

  const mutate = useCallback(
    async id => {
      await apolloService.mutate(
        DELETE_CHALLENGE_MUTATION,
        {
          id,
        },
        dispatch,
        DELETE_CHALLENGE,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useDeleteChallengeMutation
